import { FileSortOrder } from '@/types/node';
import { BaseFileView } from './BaseFileView';
import type { ImportData } from '@/types/node';
import type { FileKind, NodeId, Web, Edit } from 'web';
import type { FlowGraph } from '../FlowGraph';

export class ImportView extends BaseFileView<ImportData> {
  constructor(graph: FlowGraph, nodeId: NodeId) {
    super(graph, nodeId);
  }

  getNodeData(): ImportData {
    return this.graph.store.getNodeData<ImportData>(this.nodeId);
  }

  getFilesList(): FileKind[] {
    return this.getNodeData().files;
  }

  protected wasmSetFiles(wasm: Web, files: FileKind[]): Edit {
    return wasm.setFiles(this.nodeId, files);
  }

  /**
   * Gets the currently selected file
   */
  getCurrentFile(): FileKind | null {
    const files = this.getFilesList();
    const selectedIndex = this.getSelectedIndex();
    return files[selectedIndex] ?? null;
  }

  renameCurrentFile(name: string) {
    const files = this.getFilesList();
    const index = this.getSelectedIndex();
    if (!files[index]) return;

    const sortOrder = this.getNodeData().sortOrder;
    if (sortOrder === FileSortOrder.Name) {
      const ensured = this.ensureInsertionOrders(files);
      const renamedFile = { ...ensured[index], name };
      const updatedFiles = ensured.map((file, i) => (i === index ? renamedFile : file));
      const sorted = this.sortFilesByName(updatedFiles);
      const newIndex = sorted.indexOf(renamedFile);
      this.setFiles(sorted, newIndex, false);
    } else {
      const updatedFiles = files.map((file, i) => (i === index ? { ...file, name } : file));
      this.graph.wasmEdit((wasm) => this.wasmSetFiles(wasm, updatedFiles));
    }
  }

  setCameraLocked(locked: boolean) {
    this.graph.wasmEdit((wasm) => wasm.setCameraLocked(this.nodeId, locked));
  }
}
